// extracted by mini-css-extract-plugin
export default {"subNav":"SongsResultsLibrary_subNav__F5yVO","desktop":"SongsResultsLibrary_desktop__Up6pN"};